var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import QrCreator from 'qr-creator';
import OkCancelModal from '@/shared/components/OkCancelModal';
import ToastrService from '@/shared/services/ToastrService';
import { useGet2FA } from '@/shared/hooks/profile/useGet2FA';
import { useEnable2FA } from '@/shared/hooks/profile/useEnable2FA';
import messages from '../profileMessages';
var Enable2FAModal = function (_a) {
    var show = _a.show, onClose = _a.onClose, employeeEmail = _a.employeeEmail, employeeMobilePhone = _a.employeeMobilePhone;
    var intl = useIntl();
    var get2FA = useGet2FA().get2FA;
    var enable2FA = useEnable2FA().enable2FA;
    var qrRef = useRef(null);
    var _b = useState(null), secretData = _b[0], setSecretData = _b[1];
    var _c = useState(''), code = _c[0], setCode = _c[1];
    var _d = useState(employeeMobilePhone || ''), backupPhone = _d[0], setBackupPhone = _d[1];
    var _e = useState(false), dirty = _e[0], setDirty = _e[1];
    var showPhoneNumber = !employeeMobilePhone;
    var formValid = code.length > 0;
    useEffect(function () {
        if (!show) {
            setSecretData(null);
            setCode('');
            setBackupPhone(employeeMobilePhone || '');
            setDirty(false);
            return;
        }
        get2FA()
            .then(function (data) {
            setSecretData(data);
        })
            .catch(function () { });
    }, [show]);
    useEffect(function () {
        if (!secretData || !qrRef.current)
            return;
        qrRef.current.innerHTML = '';
        var appName = "AdminPulse".concat(secretData.environment === 'prd' ? '' : secretData.environment);
        var otpUrl = "otpauth://totp/".concat(appName, ":").concat(employeeEmail, "?secret=").concat(secretData.key);
        QrCreator.render({ text: otpUrl, size: 128 }, qrRef.current);
    }, [secretData, employeeEmail]);
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, enable2FA({ code: code, backupPhone: backupPhone })];
                case 1:
                    _a.sent();
                    ToastrService.success(intl.formatMessage(messages.TwoFAEnabled));
                    onClose();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(OkCancelModal, __assign({ title: intl.formatMessage(messages.Enable2FA), show: show, onSave: handleSave, onClose: onClose, disabled: !formValid, okLabel: intl.formatMessage(messages.Enable2FA), zendeskArticle: "6178142418322" }, { children: _jsxs("div", __assign({ className: "form-horizontal" }, { children: [_jsxs("div", __assign({ role: "alert", className: "alert alert-info" }, { children: [_jsx("div", { children: intl.formatMessage(messages.Enable2FAInfo) }), _jsxs("div", { children: [_jsx("label", { children: intl.formatMessage(messages.Enable2FAManualKey) }), ' ', _jsx("label", { children: secretData === null || secretData === void 0 ? void 0 : secretData.key })] })] })), _jsx("div", { ref: qrRef, style: {
                        width: '100%',
                        margin: '0 auto',
                        display: 'flex',
                        justifyContent: 'center',
                    } }), _jsxs("div", __assign({ className: classNames('form-group margin10T', {
                        'has-error': dirty && !code,
                    }), style: { width: '100%' } }, { children: [_jsx("label", __assign({ className: "control-label col-md-3" }, { children: intl.formatMessage(messages.Code) })), _jsxs("div", __assign({ className: "col-md-6" }, { children: [_jsx("input", { type: "text", className: "form-control", value: code, onChange: function (e) {
                                        setCode(e.target.value);
                                        setDirty(true);
                                    } }), dirty && !code && (_jsx("ul", __assign({ className: "help-block" }, { children: _jsx("li", { children: intl.formatMessage(messages.FieldRequired) }) })))] }))] })), showPhoneNumber && (_jsxs("div", __assign({ className: "form-group margin10T", style: { width: '100%' } }, { children: [_jsx("label", __assign({ className: "control-label col-md-3" }, { children: intl.formatMessage(messages.BackupPhone) })), _jsx("div", __assign({ className: "col-md-6" }, { children: _jsx("input", { type: "text", className: "form-control", value: backupPhone, onChange: function (e) { return setBackupPhone(e.target.value); }, placeholder: intl.formatMessage(messages.BackupPhone), maxLength: 125 }) }))] })))] })) })));
};
export default Enable2FAModal;
